import { canViewAllData } from '../../../shared/utils/permissions';
import type { Permission } from '../../../shared/utils/permissions';
import type { Community, CommunityGroup } from '../services/communityService';

/** `all` = admin directory on Chats list; `assigned` = membership list only (My chats). */
export type CommunityListScope = 'all' | 'assigned';

export function resolveCommunityListUsesAdminApi(
  scope: CommunityListScope | null | undefined,
  permissions: Permission[] | undefined,
  role?: string
): boolean {
  if (scope === 'assigned') return false;
  return canViewAllCommunities(permissions, role);
}

export function canViewAllCommunities(
  permissions: Permission[] | undefined,
  role?: string
): boolean {
  return canViewAllData(permissions, role);
}

export function isCommunityObserver(
  community: Pick<Community, 'my_role' | 'is_member'> | null | undefined,
  canViewAll: boolean
): boolean {
  if (!canViewAll || !community) return false;
  return !community.my_role && community.is_member !== true;
}

export function pickDefaultCommunityGroup(groups: CommunityGroup[]): CommunityGroup | null {
  return (
    groups.find((g) => g.is_default && g.is_active) ??
    groups.find((g) => g.is_active) ??
    null
  );
}
